<template>
  <div class="table-basic">
    <b-breadcrumb>
      <b-breadcrumb-item>YOU ARE HERE</b-breadcrumb-item>
      <b-breadcrumb-item>
        <router-link tag="a" to="/app/sfc-ketpo-list"
          >List Keterangan PO</router-link
        >
      </b-breadcrumb-item>
      <b-breadcrumb-item active>{{ formName }}</b-breadcrumb-item>
    </b-breadcrumb>
    <b-container fluid="lg">
      <b-row align-h="center">
        <b-col cols="12" sm="12">
          <b-card header="Master Customer Form" header-tag="header">
            <template v-slot:header>
              <div class="text-left" style="display: flex">
                <h3>Keterangan PO Form</h3>
                <h3
                  @click="reloadData()"
                  style="margin-left: 10px; cursor: pointer; color: blueviolet"
                >
                  <b-icon icon="arrow-counterclockwise"></b-icon>
                </h3>
                <b-button
                  @click="BackHistoryButton()"
                  size="md"
                  type="button"
                  variant="info"
                  style="position: absolute; right: 15px"
                >
                  <b-icon icon="arrow-left"></b-icon>
                  Back
                </b-button>
              </div>
            </template>

            <validation-observer ref="observer">
              <b-form>
                <b-row align-h="start">
                  <b-col sm="6">
                    <b-form-group
                      label="PO/SPK/SKO *"
                      label-class="text-primary"
                      label-for="PO/SPK/SKO"
                      label-cols-sm="3"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <v-select
                        append-to-body
                        :clearable="false"
                        :reduce="(data) => data.po_id"
                        v-model="noPO"
                        @input="inputPO"
                        :options="optionsPO"
                        placeholder="Select Your PO"
                        label="po_id"
                      >
                      </v-select>
                    </b-form-group>
                  </b-col>

                  <b-col sm="3">
                    <b-form-group
                      label="Part NO *"
                      label-class="text-primary"
                      label-for="PO/SPK/SKO"
                      label-cols-sm="4"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <v-select
                        append-to-body
                        :clearable="false"
                        :disabled="disabledPart"
                        v-model="noPartPO"
                        @input="inputPart"
                        :options="optionsPart"
                        placeholder="Select Your Part"
                      >
                      </v-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="6">
                    <b-form-group
                      label="Nama Customer"
                      label-cols-sm="3"
                      label-for="Nama Customer"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <b-form-input
                        v-model="customerName"
                        type="text"
                        :readonly="true"
                        trim
                      ></b-form-input>
                      <span
                        id="warning-customer"
                        class="display-hidden text-small text-danger"
                      >
                        Required
                      </span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-form-group
                      label="Jenis Customer"
                      label-for="Jenis Customer"
                      label-cols-sm="3"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <b-form-radio-group
                        v-model="customerType"
                        :disabled="true"
                        name="customer-types"
                        class="d-flex align-items-center"
                      >
                        <b-form-radio
                          v-for="option in customerOptions"
                          :key="option.value"
                          :value="option.value"
                          style="top: 6px; margin-right: 50px !important"
                          class="mr-3"
                        >
                          {{ option.text }}
                        </b-form-radio>
                      </b-form-radio-group>
                      <span
                        id="warning-type"
                        class="display-hidden text-small text-danger"
                      >
                        Required
                      </span>
                    </b-form-group>
                  </b-col>
                </b-row>

                <br />

                <b-row>
                  <b-col sm="6">
                    <h5 class="h5class"><b>IDENTITAS PENERIMA</b></h5>
                    <b-row>
                      <b-col sm="12">
                        <b-form-group
                          label="Nama"
                          label-cols-sm="4"
                          label-for="Nama"
                          label-align-sm="left"
                          label-size="sm"
                        >
                          <b-form-input
                            v-model="nameRecipt"
                            type="text"
                            trim
                          ></b-form-input>
                          <span
                            id="warning-recipt"
                            class="display-hidden text-small text-danger"
                          >
                            Required
                          </span>
                        </b-form-group>
                      </b-col>

                      <b-col sm="12">
                        <b-form-group
                          label="No Telp / E-mail"
                          label-cols-sm="4"
                          label-for="E-mail"
                          label-align-sm="left"
                          label-size="sm"
                        >
                          <b-form-input
                            v-model="infoRecipt"
                            type="text"
                            trim
                          ></b-form-input>
                          <span
                            id="warning-info-recipt"
                            class="display-hidden text-small text-danger"
                          >
                            Required
                          </span>
                        </b-form-group>
                      </b-col>

                      <b-col sm="12">
                        <b-form-group
                          label="Address"
                          label-cols-sm="4"
                          label-for="Address"
                          label-align-sm="left"
                          label-size="sm"
                        >
                          <b-form-textarea
                            v-model="addressRecipt"
                            rows="3"
                            no-resize
                          ></b-form-textarea>
                          <span
                            id="warning-address-recipt"
                            class="display-hidden text-small text-danger"
                          >
                            Required
                          </span>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col sm="6">
                    <h5 class="h5class">
                      <b>IDENTITAS PENAGIHAN PEMBAYARAN</b>
                    </h5>
                    <b-row>
                      <b-col sm="12">
                        <b-form-group
                          label="Nama"
                          label-cols-sm="4"
                          label-for="Nama"
                          label-align-sm="left"
                          label-size="sm"
                        >
                          <b-form-input
                            v-model="nameGetRecipt"
                            type="text"
                            trim
                          ></b-form-input>
                          <span
                            id="warning-getrecipt"
                            class="display-hidden text-small text-danger"
                          >
                            Required
                          </span>
                        </b-form-group>
                      </b-col>

                      <b-col sm="12">
                        <b-form-group
                          label="No Telp / E-mail"
                          label-cols-sm="4"
                          label-for="E-mail"
                          label-align-sm="left"
                          label-size="sm"
                        >
                          <b-form-input
                            v-model="infoGetRecipt"
                            type="text"
                            trim
                          ></b-form-input>
                          <span
                            id="warning-info-getrecipt"
                            class="display-hidden text-small text-danger"
                          >
                            Required
                          </span>
                        </b-form-group>
                      </b-col>

                      <b-col sm="12">
                        <b-form-group
                          label="Address"
                          label-cols-sm="4"
                          label-for="Address"
                          label-align-sm="left"
                          label-size="sm"
                        >
                          <b-form-textarea
                            v-model="addressGetRecipt"
                            rows="3"
                            no-resize
                          ></b-form-textarea>
                          <span
                            id="warning-address-getrecipt"
                            class="display-hidden text-small text-danger"
                          >
                            Required
                          </span>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <br />

                <b-row>
                  <b-col
                    sm="12"
                    class="bg-secondary text-white text-center py-2"
                  >
                    <h5
                      class="h5class"
                      style="
                        border-bottom: 0px !important;
                        position: relative;
                        top: 8px;
                      "
                    >
                      RINCIAN ORDER
                    </h5>
                  </b-col>
                </b-row>

                <br />

                <b-row>
                  <b-col sm="6">
                    <b-form-group
                      label="Tanggal Order"
                      label-cols-sm="4"
                      label-for="Address"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <VueDatePicker
                        v-model="orderDate"
                        class="vd__div"
                        no-header
                      >
                        <template #input-icon>
                          <b-icon
                            scale="1"
                            style="color: black"
                            icon="calendar3"
                          ></b-icon>
                        </template>
                      </VueDatePicker>
                      <span
                        id="warning-orderDate"
                        class="display-hidden text-small text-danger"
                      >
                        Required
                      </span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-form-group
                      label="Tanggal Diterima"
                      label-cols-sm="4"
                      label-for="Address"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <VueDatePicker
                        v-model="orderDelivery"
                        class="vd__div"
                        no-header
                      >
                        <template #input-icon>
                          <b-icon
                            scale="1"
                            style="color: black"
                            icon="calendar3"
                          ></b-icon>
                        </template>
                      </VueDatePicker>
                      <span
                        id="warning-orderDelivery"
                        class="display-hidden text-small text-danger"
                      >
                        Required
                      </span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-form-group
                      label="Pengelompokan Kemasan"
                      label-cols-sm="4"
                      label-for="Address"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <v-select
                        append-to-body
                        :clearable="false"
                        :reduce="(data) => data.value"
                        v-model="packagingGroup"
                        :options="optionsGroupPack"
                        label="value"
                      >
                      </v-select>
                      <span
                        id="warning-packagingGroup"
                        class="display-hidden text-small text-danger"
                      >
                        Required
                      </span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-form-group
                      label="Kemasan Pengiriman"
                      label-cols-sm="4"
                      label-for="Address"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <v-select
                        append-to-body
                        :clearable="false"
                        :reduce="(data) => data.value"
                        v-model="packaging"
                        :options="optionsPack"
                        label="value"
                      >
                      </v-select>
                      <span
                        id="warning-packaging"
                        class="display-hidden text-small text-danger"
                      >
                        Required
                      </span>
                    </b-form-group>
                  </b-col>
                </b-row>

                <br />

                <div v-for="(row, index) in lengthProduct" :key="row.id">
                  <h6 class="h6">
                    {{ productCat[index] }}
                    <span v-if="productArt[index]"
                      >- {{ productArt[index] }}
                    </span>
                  </h6>
                  <div
                    style="border-top: 1px solid #ccc; margin-bottom: 15px"
                  ></div>
                  <b-row>
                    <b-col sm="4">
                      <b-form-group
                       style="margin-left:3px;"
                        label="Jumlah Order"
                        label-cols-sm="6"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <b-input-group>
                          <b-input-group-prepend>
                            <span class="input-group-text">PCS </span>
                          </b-input-group-prepend>
                          <b-form-input
                            v-model="orderTotal[index]"
                            type="text"
                            :readonly="true"
                            @keypress="isNumber($event)"
                            trim
                          ></b-form-input>
                        </b-input-group>
                        <span
                          :id="'warning-orderTotal' + index"
                          class="display-hidden text-small text-danger"
                        >
                          Required
                        </span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group
                        label="Harga Satuan"
                        label-cols-sm="4"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <b-input-group>
                          <b-input-group-prepend>
                            <span class="input-group-text">RP </span>
                          </b-input-group-prepend>
                          <b-form-input
                            v-model="priceProduct[index]"
                            type="text"
                            @keypress="isNumber($event)"
                            :readonly="true"
                            trim
                          ></b-form-input>
                        </b-input-group>
                        <span
                          :id="'warning-priceProduct' + index"
                          class="display-hidden text-small text-danger"
                        >
                          Required
                        </span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group
                        label="Total Harga Order"
                        label-cols-sm="4"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <b-input-group>
                          <b-input-group-prepend>
                            <span class="input-group-text">RP </span>
                          </b-input-group-prepend>
                          <b-form-input
                            v-model="priceTotal[index]"
                            type="text"
                            @keypress="isNumber($event)"
                            :readonly="true"
                            trim
                          ></b-form-input>
                        </b-input-group>
                        <span
                          :id="'warning-priceTotal' + index"
                          class="display-hidden text-small text-danger"
                        >
                          Required
                        </span>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  
                  <b-row>
                    <b-col sm="6">
                      <b-form-group
                        label="No Sample"
                        label-cols-sm="4"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <b-form-input
                          v-model="sample[index]"
                          type="text"
                          trim
                        ></b-form-input>
                        <span
                          :id="'warning-sample' + index"
                          class="display-hidden text-small text-danger"
                        >
                          Required
                        </span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group
                        label="Merek"
                        label-cols-sm="4"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <v-select
                          append-to-body
                          :clearable="false"
                          :reduce="(data) => data.value"
                          v-model="brand[index]"
                          :options="optionsMerek"
                          label="value"
                        >
                        </v-select>
                        <span
                          :id="'warning-brand' + index"
                          class="display-hidden text-small text-danger"
                        >
                          Required
                        </span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group
                        label="Fabric"
                        label-cols-sm="4"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <b-form-input
                          v-model="fabric[index]"
                          type="text"
                          trim
                        ></b-form-input>
                        <span
                          :id="'warning-fabric' + index"
                          class="display-hidden text-small text-danger"
                        >
                          Required
                        </span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group
                        label="Kategory Produk"
                        label-cols-sm="4"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <b-form-input
                          v-model="productCat[index]"
                          type="text"
                          :readonly="true"
                          trim
                        ></b-form-input>
                        <span
                          :id="'warning-productCat' + index"
                          class="display-hidden text-small text-danger"
                        >
                          Required
                        </span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group
                        label="Keterangan Produk"
                        label-cols-sm="4"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <b-form-input
                          v-model="productInfo[index]"
                          :readonly="true"
                          type="text"
                          trim
                        ></b-form-input>
                        <span
                          :id="'warning-productInfo' + index"
                          class="display-hidden text-small text-danger"
                        >
                          Required
                        </span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group
                        label="Total Bordir"
                        label-cols-sm="4"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <v-select
                          append-to-body
                          :clearable="false"
                          :reduce="(data) => data.value"
                          v-model="embroTotal[index]"
                          :options="optionsBordir"
                          label="value"
                        >
                        </v-select>
                        <span
                          :id="'warning-embroTotal' + index"
                          class="display-hidden text-small text-danger"
                        >
                          Required
                        </span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12">
                      <b-form-group
                        label="Keterangan Bordir"
                        label-cols-sm="2"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <b-form-textarea
                          v-model="embroInfo[index]"
                          rows="3"
                          no-resize
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>

                <br />

                <!-- <b-row>
                  <b-col
                    sm="12"
                    class="bg-secondary text-white text-center py-2"
                  >
                    <h5
                      class="h5class"
                      style="
                        border-bottom: 0px !important;
                        position: relative;
                        top: 8px;
                      "
                    >
                      RINCIAN PRODUCT
                    </h5>
                  </b-col>
                </b-row> -->

                <!-- <br /> -->

                <!-- <div v-for="(row, index) in lengthProduct" :key="row.id">
                  <b-row>
                    <b-col>
                      <h6 class="h6">
                        {{ productCat[index] }}
                        <span v-if="productArt[index]"
                          >- {{ productArt[index] }}
                        </span>
                      </h6>
                    </b-col>
                  </b-row>
                  <div
                    style="border-top: 1px solid #ccc; margin-bottom: 15px"
                  ></div>
                  <b-row>
                    <b-col sm="6">
                      <b-form-group
                        label="No Sample"
                        label-cols-sm="4"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <b-form-input
                          v-model="sample[index]"
                          type="text"
                          trim
                        ></b-form-input>
                        <span
                          :id="'warning-sample' + index"
                          class="display-hidden text-small text-danger"
                        >
                          Required
                        </span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group
                        label="Merek"
                        label-cols-sm="4"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <v-select
                          append-to-body
                          :clearable="false"
                          :reduce="(data) => data.value"
                          v-model="brand[index]"
                          :options="optionsMerek"
                          label="value"
                        >
                        </v-select>
                        <span
                          :id="'warning-brand' + index"
                          class="display-hidden text-small text-danger"
                        >
                          Required
                        </span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group
                        label="Fabric"
                        label-cols-sm="4"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <b-form-input
                          v-model="fabric[index]"
                          type="text"
                          trim
                        ></b-form-input>
                        <span
                          :id="'warning-fabric' + index"
                          class="display-hidden text-small text-danger"
                        >
                          Required
                        </span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group
                        label="Kategory Produk"
                        label-cols-sm="4"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <b-form-input
                          v-model="productCat[index]"
                          type="text"
                          :readonly="true"
                          trim
                        ></b-form-input>
                        <span
                          :id="'warning-productCat' + index"
                          class="display-hidden text-small text-danger"
                        >
                          Required
                        </span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group
                        label="Keterangan Produk"
                        label-cols-sm="4"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <b-form-input
                          v-model="productInfo[index]"
                          :readonly="true"
                          type="text"
                          trim
                        ></b-form-input>
                        <span
                          :id="'warning-productInfo' + index"
                          class="display-hidden text-small text-danger"
                        >
                          Required
                        </span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group
                        label="Total Bordir"
                        label-cols-sm="4"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <v-select
                          append-to-body
                          :clearable="false"
                          :reduce="(data) => data.value"
                          v-model="embroTotal[index]"
                          :options="optionsBordir"
                          label="value"
                        >
                        </v-select>
                        <span
                          :id="'warning-embroTotal' + index"
                          class="display-hidden text-small text-danger"
                        >
                          Required
                        </span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12">
                      <b-form-group
                        label="Keterangan Bordir"
                        label-cols-sm="2"
                        label-for="E-mail"
                        label-align-sm="left"
                        label-size="sm"
                      >
                        <b-form-textarea
                          v-model="embroInfo[index]"
                          rows="3"
                          no-resize
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div> -->

                <br />

                <div
                  style="border-top: 1px solid #ccc; margin-bottom: 15px"
                ></div>

                <b-row>
                  <b-col sm="12">
                    <b-form-group
                      label="Note"
                      label-cols-sm="2"
                      label-for="E-mail"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <b-form-textarea
                        v-model="note"
                        rows="3"
                        no-resize
                      ></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>

                <br />
                <b-row align-h="end">
                  <b-col sm="3">
                    <b-button
                      v-if="!readOnlyData"
                      style="margin-right: 20px"
                      variant="success"
                      block
                      @click="checkForm()"
                    >
                      Submit</b-button
                    >
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-card>
        </b-col>
      </b-row>

      <Loader
        v-if="isLoadingData"
        fullPage
        useOverlay
        loader="spinner"
      ></Loader>
    </b-container>
  </div>
</template>

<script>
import Loader from "@/components/Loader/Loader";
import { mapGetters, mapActions, mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import Vue from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

// import vue multiselect
import Multiselect from "vue-multiselect";
import { fnPOST, fnPOSTCore } from "../../../../api/api-methods";
import { APIPATH_SALESFORCE } from "../../../../api/api-paths";

export default {
  components: {
    ModelListSelect,
    vSelect,
    Multiselect,
    Loader,
  },
  data() {
    return {
      isLoadingData: false,
      user_nik: null,
      partNo: null,
      optionsPart: [],
      disabledPart: true,
      noPartPO: null,
      username: null,
      monthNames: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      formName: "Keterangan PO Form",
      noPO: null,
      optionsPO: [],
      readOnlyData: true,
      BackHistory: null,
      project_id: null,
      pageParam: null,
      idData: null,

      customerOptions: [
        { text: "New Customer", value: "New" },
        { text: "Repeat Customer", value: "Existing" },
      ],
      optionsGroupPack: [
        { value: "Per Nama" },
        { value: "Per Ukuran" },
        { value: "Combine" },
      ],
      optionsPack: [
        { value: "Kardus Kecil" },
        { value: "Kardus Standard" },
        { value: "Kardus Besar" },
        { value: "Karung" },
      ],
      optionsMerek: [
        { value: "Valino" },
        { value: "Arnold Palmer" },
        { value: "No Brand" },
      ],
      optionsBordir: [
        { value: "Bordir 1 Titik" },
        { value: "Bordir 2 Titik" },
        { value: "Bordir 3 Titik" },
        { value: "Bordir 4 Titik" },
        { value: "Bordir 5 Titik" },
        { value: "Bordir 6 Titik" },
        { value: "Bordir 7 Titik" },
        { value: "Bordir 8 Titik" },
        { value: "Bordir 9 Titik" },
        { value: "Bordir 10 Titik" },
        { value: "Sablon 1 Titik" },
        { value: "Sablon 2 Titik" },
        { value: "Sablon 3 Titik" },
        { value: "Sablon 4 Titik" },
        { value: "Sablon 5 Titik" },
        { value: "Sablon 6 Titik" },
        { value: "Sablon 7 Titik" },
        { value: "Sablon 8 Titik" },
        { value: "Sablon 9 Titik" },
        { value: "Sablon 10 Titik" },
        { value: "Tidak Ada" },
      ],

      customerName: null,
      customerType: null,
      nameRecipt: null,
      infoRecipt: null,
      addressRecipt: null,
      nameGetRecipt: null,
      infoGetRecipt: null,
      addressGetRecipt: null,
      lengthProduct: null,
      orderDate: null,
      orderDelivery: null,
      packagingGroup: null,
      packaging: null,
      orderTotal: [],
      priceProduct: [],
      priceTotal: [],
      sample: [],
      productArt: [],
      productCat: [],
      productInfo: [],
      brand: [],
      fabric: [],
      embroTotal: [],
      embroInfo: [],
      note: null,
    };
  },

  computed: {
    ...mapGetters("session", ["userData"]),
  },
  methods: {
    ...mapActions("session", ["showNotification"]),

    reloadData() {
      this.isLoadingData = true;
      this.productCat = [];
      this.productInfo = [];
      this.productArt = [];
      this.orderTotal = [];
      this.priceProduct = [];
      this.priceTotal = [];

      fnPOST(APIPATH_SALESFORCE.getDetailPOEdit, {
        po: this.noPO,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          if (rsp.data.payload) {
            let data = rsp.data.payload[0];
            this.readOnlyData = false;
            this.customerName = data.customer_name;
            this.customerType = data.status;
            this.nameRecipt = data.location_name;
            this.addressRecipt = data.address;
            this.nameGetRecipt = data.location_name_bil;
            this.addressGetRecipt = data.address_bil;
            this.orderDate = data.period_date;
            this.project_id = data.project_id;
            this.isLoadingData = true;
            fnPOST(APIPATH_SALESFORCE.getPOProduct, {
              project_id: data.project_id,
              part_no: this.noPartPO,
            })
              .then((rspD) => {
                this.isLoadingData = false;
                let order = rspD.data.payload;
                if (order) {
                  this.orderTotal = [];
                  this.priceProduct = [];
                  this.priceTotal = [];
                  this.productCat = [];
                  this.productInfo = [];
                  this.productArt = [];
                  this.lengthProduct = order.length;
                  this.orderDelivery = order[0].est_shipment_month;
                  order.forEach((val) => {
                    this.orderTotal.push(val.qty);
                    this.priceProduct.push(
                      parseFloat(val.est_item_price)
                        .toString()
                        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                    );
                    this.priceTotal.push(
                      (parseFloat(val.est_item_price) * val.qty)
                        .toString()
                        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                    );
                    this.productCat.push(val.item);
                    if (val.color_name) {
                      this.productInfo.push(
                        val.item + " (" + val.color_name + ")"
                      );
                    }
                    if (val.article) {
                      this.productArt.push(val.article);
                    }
                  });
                }
              })
              .catch((err) => {
                this.isLoadingData = false;
                this.showNotification({ type: "error", message: err });
              });
          }
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    loadEdit() {
      this.readOnlyData = false;
      this.user_nik = this.userData.nik;
      this.username = this.userData.fullname;
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.getFormPO, {
        idData: this.idData,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          let data = rsp.data.payload[0];
          this.noPO = data.po;
          this.noPartPO = data.part_no;
          this.project_id = data.project_id;
          this.customerName = data.customer_name;
          this.customerType = data.type_customer;
          this.note = data.note;
          this.loadDataPORecip();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    loadDataPORecip() {
      fnPOST(APIPATH_SALESFORCE.getFormPORecipt, {
        idData: this.idData,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          let data = rsp.data.payload[0];
          let dataB = rsp.data.payload[1];
          this.nameRecipt = data.name;
          this.infoRecipt = data.name_info;
          this.addressRecipt = data.address;
          this.nameGetRecipt = dataB.name;
          this.infoGetRecipt = dataB.name_info;
          this.addressGetRecipt = dataB.address;
          this.loadDataPOOrder();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    loadDataPOOrder() {
      fnPOST(APIPATH_SALESFORCE.getFormPOOrder, {
        idData: this.idData,
      })
        .then((rsp) => {
          this.orderTotal = [];
          this.priceProduct = [];
          this.priceTotal = [];
          this.productCat = [];
          this.productInfo = [];
          this.productArt = [];
          this.isLoadingData = false;
          let data = rsp.data.payload;
          this.orderDate = data[0].order_date;
          this.orderDelivery = data[0].delivery_date;
          this.packaging = data[0].packaging_type;
          this.packagingGroup = data[0].packaging_group;
          this.lengthProduct = data.length;
          data.forEach((val) => {
            this.orderTotal.push(val.order_qty);
            this.priceProduct.push(
              parseFloat(val.price_pcs)
                .toString()
                .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
            );
            this.priceTotal.push(
              parseFloat(val.price_total)
                .toString()
                .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
            );
          });
          this.loadDataPOProduct();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    loadDataPOProduct() {
      fnPOST(APIPATH_SALESFORCE.getFormPOProduct, {
        idData: this.idData,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          let data = rsp.data.payload;
          this.sample = [];
          this.productCat = [];
          this.productInfo = [];
          this.productArt = [];
          this.brand = [];
          this.fabric = [];
          this.embroTotal = [];
          this.embroInfo = [];
          data.forEach((val) => {
            this.sample.push(val.sample_no);
            this.productCat.push(val.product_category);
            this.productInfo.push(val.product_info);
            this.productArt.push(val.product_art);
            this.brand.push(val.brand);
            this.embroTotal.push(val.embro_total);
            this.embroInfo.push(val.embro_info);
            this.fabric.push(val.fabric);
          });
          // this.loadPdfArray();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },
    setData() {
      this.isLoadingData = true;
      this.user_nik = this.userData.nik;
      this.username = this.userData.fullname;

      fnPOST(APIPATH_SALESFORCE.getDataPO, {})
        .then((rsp) => {
          this.optionsPO = [];
          this.isLoadingData = false;
          if (rsp.data.payload) {
            this.optionsPO = rsp.data.payload;
          }
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    inputPart() {
      if (this.noPartPO) {
        this.loadDetailData();
      }
    },

    inputPO() {
      if (this.noPO) {
        this.optionsPart = [];
        this.noPartPO = null;
        this.disabledPart = true;
        this.optionsPO.forEach((val) => {
          if (val.po_id == this.noPO) {
            if (val.part_no) {
              this.partNo = val.part_no;
              this.disabledPart = false;
              for (let a = 0; a < this.partNo; a++) {
                this.optionsPart.push(a + 1);
              }
            } else {
              this.partNo = null;
            }
          }
        });
      }
    },

    loadDetailData() {
      this.isLoadingData = true;
      this.sample = [];
      this.productCat = [];
      this.productInfo = [];
      this.productArt = [];
      this.orderTotal = [];
      this.priceTotal = [];
      this.priceProduct = [];
      this.brand = [];
      this.fabric = [];
      this.embroTotal = [];
      this.embroInfo = [];
      this.orderTotal = [];
      this.priceProduct = [];
      this.priceTotal = [];

      fnPOST(APIPATH_SALESFORCE.getDetailPO, {
        po: this.noPO,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          if (rsp.data.payload) {
            let data = rsp.data.payload[0];
            this.readOnlyData = false;
            this.customerName = data.customer_name;
            this.customerType = data.status;
            this.nameRecipt = data.location_name;
            this.infoRecipt = data.phone;
            this.addressRecipt = data.address;
            this.nameGetRecipt = data.location_name_bil;
            this.infoGetRecipt = data.phone_bill;
            this.addressGetRecipt = data.address_bil;
            this.orderDate = data.period_date;
            this.project_id = data.project_id;
            this.isLoadingData = true;
            fnPOST(APIPATH_SALESFORCE.getPOProduct, {
              project_id: data.project_id,
              part_no: this.noPartPO,
            })
              .then((rspD) => {
                this.isLoadingData = false;
                let order = rspD.data.payload;
                if (order) {
                  this.lengthProduct = order.length;
                  this.orderDelivery = order[0].est_shipment_month;
                  order.forEach((val) => {
                    this.orderTotal.push(val.qty);
                    this.priceProduct.push(
                      parseFloat(val.est_item_price)
                        .toString()
                        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                    );
                    this.priceTotal.push(
                      (parseFloat(val.est_item_price) * val.qty)
                        .toString()
                        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                    );
                    this.productCat.push(val.item);
                    if (val.color_name) {
                      this.productInfo.push(
                        val.item + " (" + val.color_name + ")"
                      );
                    }
                    if (val.article) {
                      this.productArt.push(val.article);
                    }
                  });
                }
              })
              .catch((err) => {
                this.isLoadingData = false;
                this.showNotification({ type: "error", message: err });
              });

            // this.sample = [];
            // this.productCat = [];
            // this.productInfo = [];
            // this.brand = [];
            // this.fabric = [];
            // this.embroTotal = [];
            // this.embroInfo = [];
            this.note = null;
          }
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    addTag(value) {
      // console.log(this.options.groupCustomer)
      const tag = {
        name: value,
        is_active: true,
      };
      this.options.groupCustomer.push(tag);
      this.selectCustomerGroup = tag;
      this.addCustomerGroup = true;
    },
    toString(value) {
      let text = null;
      if (value.length != 0) {
        text = value.replace(/[^a-zA-Z ]/g, "");
      }
      return text;
    },
    BackHistoryButton() {
      let pageView = "SFCKetPOList";
      let data = null;
      this.$router.push({
        name: pageView,
        params: { page: "view", idData: data },
      });
    },

    FormatDate(value) {
      if (value == null || value == undefined || value == "") {
        return " ";
      } else {
        let date = new Date(value);
        let day = date.getDate();
        if (String(day).length == 1) {
          day = "0" + String(day);
        }
        let year = date.getFullYear();
        let bulan = this.monthNames[date.getMonth()];
        date = day + " " + bulan + " " + year;
        return date;
      }
    },

    checkForm() {
      console.log("test");
      if (
        this.customerName == null ||
        this.customerName == "" ||
        this.customerName.substring(0, 1) == " "
      ) {
        this.showNotification({
          type: "info",
          message: "Nama Customer Wajib di isi",
        });
        document
          .getElementById("warning-customer")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-customer")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }

      if (
        this.customerType == null ||
        this.customerType == "" ||
        this.customerType.substring(0, 1) == " "
      ) {
        this.showNotification({
          type: "info",
          message: "Jenis Customer Wajib di isi",
        });
        document
          .getElementById("warning-type")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-type")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }
      if (
        this.nameRecipt == null ||
        this.nameRecipt == "" ||
        this.nameRecipt.substring(0, 1) == " "
      ) {
        this.showNotification({
          type: "info",
          message: "Nama Penerima Wajib di isi",
        });
        document
          .getElementById("warning-recipt")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-recipt")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }
      if (
        this.infoRecipt == null ||
        this.infoRecipt == "" ||
        this.infoRecipt.substring(0, 1) == " "
      ) {
        this.showNotification({
          type: "info",
          message: "Telp/Email Penerima Wajib di isi",
        });
        document
          .getElementById("warning-info-recipt")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-info-recipt")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }

      if (
        this.addressRecipt == null ||
        this.addressRecipt == "" ||
        this.addressRecipt.substring(0, 1) == " "
      ) {
        this.showNotification({
          type: "info",
          message: "Alamat Penerima Wajib di isi",
        });
        document
          .getElementById("warning-address-recipt")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-address-recipt")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }

      if (
        this.nameGetRecipt == null ||
        this.nameGetRecipt == "" ||
        this.nameGetRecipt.substring(0, 1) == " "
      ) {
        this.showNotification({
          type: "info",
          message: "Nama Penagih Wajib di isi",
        });
        document
          .getElementById("warning-getrecipt")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-getrecipt")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }

      if (
        this.infoGetRecipt == null ||
        this.infoGetRecipt == "" ||
        this.infoGetRecipt.substring(0, 1) == " "
      ) {
        this.showNotification({
          type: "info",
          message: "Telp / Email Penagih Wajib di isi",
        });
        document
          .getElementById("warning-info-getrecipt")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-info-getrecipt")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }

      if (
        this.addressGetRecipt == null ||
        this.addressGetRecipt == "" ||
        this.addressGetRecipt.substring(0, 1) == " "
      ) {
        this.showNotification({
          type: "info",
          message: "Alamat Penagih Wajib di isi",
        });
        document
          .getElementById("warning-address-getrecipt")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-address-getrecipt")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }

      if (
        this.orderDate == null ||
        this.orderDate == "" ||
        this.orderDate.substring(0, 1) == " "
      ) {
        this.showNotification({
          type: "info",
          message: "Tanggal Order Wajib di isi",
        });
        document
          .getElementById("warning-orderDate")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-orderDate")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }

      if (
        this.orderDelivery == null ||
        this.orderDelivery == "" ||
        this.orderDelivery.substring(0, 1) == " "
      ) {
        this.showNotification({
          type: "info",
          message: "Tanggal Diterima Wajib di isi",
        });
        document
          .getElementById("warning-orderDelivery")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-orderDelivery")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }

      if (
        this.packagingGroup == null ||
        this.packagingGroup == "" ||
        this.packagingGroup.substring(0, 1) == " "
      ) {
        this.showNotification({
          type: "info",
          message: "Pengelompokan Kemasan Wajib di isi",
        });
        document
          .getElementById("warning-packagingGroup")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-packagingGroup")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }

      if (
        this.packaging == null ||
        this.packaging == "" ||
        this.packaging.substring(0, 1) == " "
      ) {
        this.showNotification({
          type: "info",
          message: "Kemasan Pengiriman Wajib di isi",
        });
        document
          .getElementById("warning-packaging")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-packaging")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }

      for (let a = 0; a < this.lengthProduct; a++) {
        if (!(this.orderTotal[a] > 0)) {
          this.showNotification({
            type: "info",
            message: "Jumlah Order Wajib di isi",
          });
          document
            .getElementById(`warning-orderTotal${a}`)
            .classList.remove("display-hidden");
          setTimeout(() => {
            document
              .getElementById(`warning-orderTotal${a}`)
              .classList.add("display-hidden");
          }, 5000);
          return false;
        }

        if (
          this.priceProduct[a] == null ||
          this.priceProduct[a] == "" ||
          this.priceProduct[a].substring(0, 1) == " "
        ) {
          this.showNotification({
            type: "info",
            message: "Harga Satuan Wajib di isi",
          });
          document
            .getElementById(`warning-priceProduct${a}`)
            .classList.remove("display-hidden");
          setTimeout(() => {
            document
              .getElementById(`warning-priceProduct${a}`)
              .classList.add("display-hidden");
          }, 5000);
          return false;
        }

        if (
          this.priceTotal[a] == null ||
          this.priceTotal[a] == "" ||
          this.priceTotal[a].substring(0, 1) == " "
        ) {
          this.showNotification({
            type: "info",
            message: "Total Harga Wajib di isi",
          });
          document
            .getElementById(`warning-priceTotal${a}`)
            .classList.remove("display-hidden");
          setTimeout(() => {
            document
              .getElementById(`warning-priceTotal${a}`)
              .classList.add("display-hidden");
          }, 5000);
          return false;
        }

        // if (
        //   this.sample[a] == null ||
        //   this.sample[a] == "" ||
        //   this.sample[a].substring(0, 1) == " "
        // ) {
        //   this.showNotification({
        //     type: "info",
        //     message: "No Sample Wajib di isi",
        //   });
        //   document
        //     .getElementById(`warning-sample${a}`)
        //     .classList.remove("display-hidden");
        //   setTimeout(() => {
        //     document
        //       .getElementById(`warning-sample${a}`)
        //       .classList.add("display-hidden");
        //   }, 5000);
        //   return false;
        // }

        if (
          this.brand[a] == null ||
          this.brand[a] == "" ||
          this.brand[a].substring(0, 1) == " "
        ) {
          this.showNotification({
            type: "info",
            message: "Merek Wajib di isi",
          });
          document
            .getElementById(`warning-brand${a}`)
            .classList.remove("display-hidden");
          setTimeout(() => {
            document
              .getElementById(`warning-brand${a}`)
              .classList.add("display-hidden");
          }, 5000);
          return false;
        }

        if (
          this.fabric[a] == null ||
          this.fabric[a] == "" ||
          this.fabric[a].substring(0, 1) == " "
        ) {
          this.showNotification({
            type: "info",
            message: "Fabric Wajib di isi",
          });
          document
            .getElementById(`warning-fabric${a}`)
            .classList.remove("display-hidden");
          setTimeout(() => {
            document
              .getElementById(`warning-fabric${a}`)
              .classList.add("display-hidden");
          }, 5000);
          return false;
        }

        if (
          this.productCat[a] == null ||
          this.productCat[a] == "" ||
          this.productCat[a].substring(0, 1) == " "
        ) {
          this.showNotification({
            type: "info",
            message: "Kategory Produk Wajib di isi",
          });
          document
            .getElementById(`warning-productCat${a}`)
            .classList.remove("display-hidden");
          setTimeout(() => {
            document
              .getElementById(`warning-productCat${a}`)
              .classList.add("display-hidden");
          }, 5000);
          return false;
        }

        if (
          this.productInfo[a] == null ||
          this.productInfo[a] == "" ||
          this.productInfo[a].substring(0, 1) == " "
        ) {
          this.showNotification({
            type: "info",
            message: "Keterangan Produk Wajib di isi",
          });
          document
            .getElementById(`warning-productInfo${a}`)
            .classList.remove("display-hidden");
          setTimeout(() => {
            document
              .getElementById(`warning-productInfo${a}`)
              .classList.add("display-hidden");
          }, 5000);
          return false;
        }

        if (
          this.embroTotal[a] == null ||
          this.embroTotal[a] == "" ||
          this.embroTotal[a].substring(0, 1) == " "
        ) {
          this.showNotification({
            type: "info",
            message: "Total Bordir Wajib di isi",
          });
          document
            .getElementById(`warning-embroTotal${a}`)
            .classList.remove("display-hidden");
          setTimeout(() => {
            document
              .getElementById(`warning-embroTotal${a}`)
              .classList.add("display-hidden");
          }, 5000);
          return false;
        }
      }
      if (this.pageParam == "edit") {
        this.editForm();
      } else {
        this.submitForm();
      }
    },

    editForm() {
      let data = {
        idData: this.idData,
        customer: this.customerName,
        customer_status: this.customerType,
        po: this.noPO,
        part_no: this.noPartPO,
        project_id: this.project_id,
        name_recipt: this.nameRecipt,
        address_recipt: this.addressRecipt,
        info_recipt: this.infoRecipt,
        name_get_recipt: this.nameGetRecipt,
        address_get_recipt: this.addressGetRecipt,
        info_get_recipt: this.infoGetRecipt,
        order_date: this.orderDate,
        delivery_date: this.orderDelivery,
        packaging: this.packaging,
        packaging_group: this.packagingGroup,
        order_qty: this.orderTotal,
        price_pcs: this.priceProduct,
        price_total: this.priceTotal,
        sample: this.sample,
        fabric: this.fabric,
        brand: this.brand,
        product_Info: this.productInfo,
        product_cat: this.productCat,
        product_art: this.productArt,
        embro_total: this.embroTotal,
        embro_info: this.embroInfo,
        note: this.note,
        updated_by: this.user_nik,
        updated_by_name: this.username,
      };
      this.isLoadingData = true;

      fnPOST(APIPATH_SALESFORCE.editKeteranganPO, {
        data: data,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          this.showNotification({
            type: "success",
            message: "Successfully Submitted",
          });
          this.BackHistoryButton();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    submitForm() {
      let data = {
        po: this.noPO,
        part_no: this.noPartPO,
        name_recipt: this.nameRecipt,
        address_recipt: this.addressRecipt,
        info_recipt: this.infoRecipt,
        project_id: this.project_id,
        name_get_recipt: this.nameGetRecipt,
        address_get_recipt: this.addressGetRecipt,
        info_get_recipt: this.infoGetRecipt,
        order_date: this.orderDate,
        delivery_date: this.orderDelivery,
        packaging: this.packaging,
        packaging_group: this.packagingGroup,
        sample: this.sample,
        fabric: this.fabric,
        brand: this.brand,
        product_Info: this.productInfo,
        product_art: this.productArt,
        embro_total: this.embroTotal,
        embro_info: this.embroInfo,
        note: this.note,
        updated_by: this.user_nik,
        updated_by_name: this.username,
      };
      this.isLoadingData = true;

      fnPOST(APIPATH_SALESFORCE.postKeteranganPO, {
        data: data,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          this.showNotification({
            type: "success",
            message: "Successfully Submitted",
          });
          this.BackHistoryButton();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },
  },
  created() {
    this.idData = this.$route.params.idData;
    this.pageParam = this.$route.params.page;
    if (this.$route.params.page == "edit") {
      this.loadEdit();
    } else {
      this.setData();
    }
  },
};
</script>
<style scoped>
.form-control {
  color: #000 !important;
}
.h6 {
  font-weight: 500 !important;
}
.h5class {
  text-transform: uppercase;
  margin-bottom: 15px;
  border-bottom: 1px solid #000;
  padding-bottom: 5px;
}
#modal .vd__div {
  background: white;
}
</style>
<style src="../SalesForce.scss" lang="scss" scoped />
//
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
